import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { adrPlugin, isAdrAvailable } from '@backstage-community/plugin-adr';

/*
 * Replaces the ADR plugin's own entity tab with the same content inside a scope
 * class, so `adr.css` can bring the page to the TechDocs reader's grammar.
 *
 * `adrEntityContentExtension` is `EntityContentBlueprint.make({ name: 'entity' })`
 * on plugin `adr`, giving it the id `entity-content:adr/entity`; an extension of
 * the same name in an `adr` module takes that id and stands in for it. Its
 * params are re-supplied verbatim — the route ref included, since the ADR list
 * builds its links from `useRouteRef(rootRouteRef)`.
 */
const adrEntityContent = EntityContentBlueprint.make({
  name: 'entity',
  params: {
    path: '/adrs',
    title: 'ADRs',
    filter: isAdrAvailable,
    routeRef: convertLegacyRouteRef(adrPlugin.routes.root),
    loader: () =>
      import('./AdrEntityContent').then(m => <m.AdrEntityContent />),
  },
});

export const adrModule = createFrontendModule({
  pluginId: 'adr',
  extensions: [adrEntityContent],
});
